import { createFileRoute } from '@tanstack/react-router';

import { LabsCatalogue } from 'features/labs';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/labs/')({
  staticData: { breadcrumb: 'labs' },
  component: LabsCatalogueRoute
});

function LabsCatalogueRoute() {
  const { id } = Route.useParams();

  return <LabsCatalogue locationId={id} />;
}
